import React from "react";
import { Box, Grid } from "@mui/material";
import { useNavigate } from "react-router";
import { HeaderMegaMenuSX } from "../../../headerMegaMenu";
import { StyledPaper } from "@hcl-commerce-store-sdk/react-component";
import { StyledMenuTitle, StyledMenuSubtitle, StyledMenuHeading, StyledMenuLink, StyledMenuButton } from "../../style";
import { DesktopActionCard } from "../DesktopActionCards";
import { PRISEDERDV } from "../../../../../constants/routes";
import AsyncCall from "../../../../../_foundation/gtm/async.service";
import { CLICK } from "../../../../../_foundation/constants/gtm";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

interface DesktopOutilsMenuProps {
  closeHeaderMenu?: () => any;
  menuLinksData: Record<string, any>;
}

const DesktopOutilsMenu: React.FC<DesktopOutilsMenuProps> = ({ closeHeaderMenu, menuLinksData }) => {
  const navigate = useNavigate();

  const OutilsData = menuLinksData?.outils;
  const univers = OutilsData?.Univers || [];
  const NAV_LEVEL_1 = "Outils De Conception";

  const onOutilsBtnClick = () => {
    AsyncCall.sendClick(CLICK.NAV, {
      click_section: "menu",
      nav_level_1: NAV_LEVEL_1,
      nav_level_2: "",
      nav_level_3: "",
      nav_type: "cta",
      btn_label: "Voir tous nos configurateurs",
      click_destination: OutilsData?.url || "",
    });
    closeHeaderMenu && closeHeaderMenu();
    navigate(OutilsData?.url);
  };

  const onItemClickHandler = (event: React.MouseEvent, universe: Record<string, any>, item: Record<string, any>) => {
    event.preventDefault();
    const url = item?.link?.url;
    const type = (item?.link?.type || "internal").toLowerCase();
    closeHeaderMenu && closeHeaderMenu();

    AsyncCall.sendClick(CLICK.NAV, {
      click_section: "menu",
      nav_level_1: NAV_LEVEL_1,
      nav_level_2: universe?.name || "",
      nav_level_3: item?.title || "",
      nav_type: "link",
      btn_label: item?.title || "",
      click_destination: url,
    });

    if (url && type === "external") {
      window.open(url, "_blank", "noopener,noreferrer");
    } else if (url) {
      navigate(url);
    }
  };

  if (!OutilsData) return null;

  return (
    <StyledPaper className="megamenu-wrapper expanded-menu-mega-menu-v2" sx={HeaderMegaMenuSX.wrapper}>
      <Box>
        <StyledMenuTitle sx={{ mb: 1 }}>{OutilsData.label}</StyledMenuTitle>
        <StyledMenuSubtitle sx={{ mb: 1 }}>{OutilsData.description}</StyledMenuSubtitle>

        {/* Columns — responsive: 1 column on xs, 2 on sm, 3-4 on md+ depending on items */}
        <Grid
          container
          spacing={4}
          sx={{
            mt: 2,
            flexWrap: "nowrap", // 🚀 prevents row break
          }}>
          {/* LEFT SIDE WRAPPER */}
          <Grid item xs={12} md>
            {/* UTILITIES GRID (multiple columns preserved) */}
            <Grid container spacing={4}>
              {univers.map((u: any, idx: number) => (
                <Grid item key={idx} xs={12} sm={6} md={2.4}>
                  <StyledMenuHeading sx={{ mb: 1, color: "#252427", fontSize: "15px" }}>{u.name}</StyledMenuHeading>

                  <Box sx={{ display: "flex", flexDirection: "column", mt: 1 }}>
                    {(u.configurateurs || []).map((c: any, i: number) => (
                      <StyledMenuLink key={i} onClick={(e) => onItemClickHandler(e, u, c)} role="link">
                        <span style={{ marginLeft: 0 }}>{c.title}</span>
                      </StyledMenuLink>
                    ))}
                  </Box>
                </Grid>
              ))}
            </Grid>

            {/* BUTTON BELOW UTILITIES */}
            <Box sx={{ mt: 4 }}>
              <StyledMenuButton onClick={onOutilsBtnClick}>
                Voir tous nos configurateurs
                <ArrowForwardIcon sx={{ ml: 1 }} />
              </StyledMenuButton>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md="auto"
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flexBasis: { md: "352px" }, // fixed width on desktop
              maxWidth: { md: "352px" },
              flexGrow: 0,
              mr: 4,
            }}>
            <Box
              sx={{
                width: "5px",
                backgroundColor: "#EFEFEF",
                marginRight: "16px",
              }}
            />
            <DesktopActionCard
              closeHeaderMenu={closeHeaderMenu}
              cardTheme="red"
              chipName="AIDE"
              title="BESOIN DE CONSEIL"
              desc="Nos équipes sont là pour vous conseiller à chaque étape de votre projet. Prenez rendez-vous avec un
                  expert."
              btnLabel="PRENDRE RENDEZ-VOUS"
              ctaLink={PRISEDERDV}
              rdvTracking={{
                navigation_location: "menu",
                click_destination: PRISEDERDV,
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </StyledPaper>
  );
};

export default DesktopOutilsMenu;
